import type { TFunction } from 'i18next';

export const CHECKOUT_FIELD_TYPE_ENUM = {
  TEXT: 'TEXT',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  ADDRESS: 'ADDRESS',
} as const;

export const checkoutFieldTypei18n = (
  t: TFunction,
  key: string | undefined,
) => {
  const keys = {
    [CHECKOUT_FIELD_TYPE_ENUM.TEXT]: t('Text'),
    [CHECKOUT_FIELD_TYPE_ENUM.EMAIL]: t('Email'),
    [CHECKOUT_FIELD_TYPE_ENUM.PHONE]: t('Phone'),
    [CHECKOUT_FIELD_TYPE_ENUM.ADDRESS]: t('Address'),
  };

  return keys[key as keyof typeof CHECKOUT_FIELD_TYPE_ENUM] || '';
};
